import IndustryPageTemplate from "./IndustryPageTemplate";
import { eventPlannersData } from "@/data/eventPlanners";

export default function EventPlannersPage() {
  return <IndustryPageTemplate data={eventPlannersData} />;
}
